// extracted by mini-css-extract-plugin
export default {"link":"NhSDr","footer":"ktxiN","avatar":"AIans","avatar-container":"I1k9t","placeholder":"QamYl","action-container":"QeeTI","action":"EFVoY"};